import Overlay from './Overlay.js';
import { el } from '../dom.js';
import { SCHEME_INFO, SCHEME_ORDER } from '../../input/ControlScheme.js';
import { controlsReference } from '../../input/bindings.js';
import { load as loadSettings } from '../../core/UserSettings.js';

/**
 * Controls reference — a tab per control scheme, each with its binding tables
 * grouped by role. The tables live beside the bindings themselves
 * (`input/bindings.js`), so there's one file to keep in step. Opens on the
 * scheme the player has selected.
 */
export default class ControlsOverlay extends Overlay {
  constructor({ onClose }) {
    super({ title: 'CONTROLS', onClose });

    this._tabs = el('div', 'controls-tabs');
    this._buttons = SCHEME_ORDER.map((key) => {
      const b = el('button', 'seg-btn', SCHEME_INFO[key].label);
      b.type = 'button';
      b.addEventListener('click', () => this._show(key));
      this._tabs.appendChild(b);
      return { key, b };
    });
    this.body.appendChild(this._tabs);
    this._note = el('div', 'controls-scheme-note');
    this.body.appendChild(this._note);
    this._tables = el('div');
    this.body.appendChild(this._tables);

    this._show(loadSettings().controlScheme);
  }

  setVisible(v) {
    if (v && this._buttons) this._show(loadSettings().controlScheme);
    super.setVisible(v);
  }

  _show(scheme) {
    if (!SCHEME_INFO[scheme]) scheme = SCHEME_ORDER[0];
    for (const { key, b } of this._buttons) b.classList.toggle('is-active', key === scheme);
    this._note.textContent = `${SCHEME_INFO[scheme].name} — ${SCHEME_INFO[scheme].blurb}`;
    this._tables.replaceChildren();
    for (const [title, bindings] of controlsReference(scheme)) {
      const group = el('div', 'controls-group');
      group.appendChild(el('div', 'controls-group-title', title));
      const table = el('div', 'controls-table');
      for (const [key, action] of bindings) {
        const row = el('div', 'controls-row');
        row.appendChild(el('span', 'controls-key', key));
        row.appendChild(el('span', 'controls-action', action));
        table.appendChild(row);
      }
      group.appendChild(table);
      this._tables.appendChild(group);
    }
  }
}
